import InfoIcon from "@mui/icons-material/Info";
import { Box, Typography } from "@mui/material";
import { Flex } from "../../../../base/components/Flex";
import { useTranslationPrefix } from "../../../../hooks/useTranslationPrefix";
import InfoTooltip from "./InfoTooltip";

interface Props {
  color: string;
  description: string;
  size?: "small" | "large";
}

const QrInfoTag = ({ color, description, size }: Props) => {
  const { _t } = useTranslationPrefix("LaunchPlaylistQrPageNew");
  return (
    <InfoTooltip
      stopClickPropagation
      title={
        <Flex flexDirection="column" gap={1} maxHeight="60vh" overflow="auto">
          <Typography whiteSpace="pre-wrap">{description}</Typography>
        </Flex>
      }
    >
      <Box
        alignItems="center"
        sx={{
          display: "flex",
          alignItems: "center",
          backgroundColor: "white.main",
          borderRadius: 2,
          px: size === "large" ? 1 : 0.5,
          py: size === "large" ? 0.5 : undefined,
          position: "absolute",
          right: 12,
          bottom: size === "large" ? 16 : 8,
        }}
      >
        <InfoIcon
          sx={{
            color: { color },
            fontSize: "1.25rem",
          }}
        />
        <Typography
          sx={{ color: color, fontSize: size === "large" ? "1rem" : "0.85rem" }}
        >
          {_t("infoButtonText", "info")}
        </Typography>
      </Box>
    </InfoTooltip>
  );
};

export default QrInfoTag;
